import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomRadioGroup from '../base/CustomRadioGroup';

/**
 * Prompt user for input: sponsor
 * @param {string|ReactElement} labelUsernameType label of the user type (defaults to 'user')
 * @returns {ReactElement} field asking if the requestor intends to be the sponsor
 */
const SelfSponsor = ({ labelUsernameType = 'user' }) => {
	return (
		<CustomRadioGroup
			id={'self-sponsor-check'}
			label={
				'Do you intend to be the sponsor of the new ' +
				labelUsernameType +
				'?'
			}
			options={[
				{ label: 'Yes', value: true },
				{ label: 'No', value: false },
			]}
			name={NEW_NON_EMPLOYEE_KEYS.SELF_SPONSOR}
			required
			row
		/>
	);
};
export default SelfSponsor;
